<template>
  <div class="animated fadeIn">
    <b-modal  ref="modal-new-followup" scrollable centered button-size="sm" v-on:hide="hideModal" v-on:close="aborted">
      <template #modal-title>
        <i class="fas fa-comments"></i>&nbsp; FOLLOW UP
      </template>
      <div class="form-group row">
        <div class="col-md-12">
          <label for="txtGroup"><small class="text-danger">*</small> Tipo de Evento:</label>
          <div class="input-group">
            <b-form-select v-model="form.eventoId.value" :options="form.eventoId.options" class="mb-3" @change="onChangeEvent">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtData"><small class="text-danger">*</small> Data:</label>
          <div class="input-group">
            <b-form-input type="date"
                          id="txtData"
                          name="txtData"
                          style="height: 35px;"
                          v-model="form.data.value"
                          :required="showFieldHorario"
                          :state="form.data.state"
                          @change="onCheckDate"/>
          </div>
        </div>

        <!-- <div v-if="showFieldsDespesas && showFieldHorario" class="col-md-8" style="align-self: end;">
          <button type="button" class="btn rounded btn-third w-100" @click="onShowDespesasModal" v-b-tooltip.hover title="Adicionar despesas"><i class="fas fa-plus"></i>&nbsp; Adicionar despesas</button>
        </div> -->

        <div class="col-md-6" v-if="showFieldHorario">
          <label for="txtHorario">Horário:</label>
            <FormulateInput
                type="time"
                name="horario"
                input-class="form-control"
                :value="form.horario.value"
                v-on:blur="updateHorario"
            />
        </div>

        <div class="col-md-12 mt-3" v-if="showFieldHorario">
          <label for="txtGroup"><small v-if="form.boardColumnId.required" class="text-danger">*</small> Mover para:</label>
          <div class="input-group">
            <b-form-select v-model="form.boardColumnId.value" :options="form.boardColumnId.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>

      </div>

      <div class="form-group row mt-3" v-if="showFieldsDeslocamento">
        <div class="col-md-6">
          <label for="txtName"><small class="text-danger">*</small> Km Inicial:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-road"></i></span>
            <b-form-input type="number"
                          min="0"
                          :placeholder="'Digite o Km Inicial'"
                          v-model="form.kmInicial.value"
                          :size="form.kmInicial.maxlength"
                          :required="form.kmInicial.required"
                          :state="form.kmInicial.state"
                          @blur="onCheckKm"></b-form-input>
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtName"><small class="text-danger">*</small> Km Final:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-road"></i></span>
            <b-form-input type="number"
                          min="0"
                          :placeholder="'Digite o Km Final'"
                          v-model="form.kmFinal.value"
                          :size="form.kmFinal.maxlength"
                          :required="form.kmFinal.required"
                          :state="form.kmFinal.state"
                          @blur="onCheckKm"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row mt-3">
        <div class="col-md-12">
          <label for="txtDetalhes"><small class="text-danger">*</small> Detalhes:</label>
          <b-form-textarea id="txtDetalhes"
                      name="txtDetalhes"
                      v-model="form.detalhes.value"
                      :placeholder="'Digite os detalhes do follow-up aqui'"
                      :rows="form.detalhes.rows"
                      :size="form.detalhes.maxlength"
                      :noResize="form.detalhes.noResize"></b-form-textarea>
        </div>
      </div>

      <div class="form-group row pt-2" v-if="showFieldsDespesas">
        <div v-if="data.despesas && data.despesas.length > 0" class="col-md pt-2 pb-2">
          <b-link @click="onShowDespesasModal">{{data.despesas && data.despesas.length}} Despesas Criadas. Total: {{valorTotalDespesas.toLocaleString('pt-Br', { style: 'currency', currency: 'BRL' })}}</b-link>
          <!-- <p></p> -->
        </div>

        <div class="col-md-12">
          <button type="button" class="btn rounded btn-third w-100" @click="onShowDespesasModal" v-b-tooltip.hover title="Adicionar despesas"><i class="fas fa-plus"></i>&nbsp; Adicionar despesas</button>&nbsp;
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12 pt-2">
          <label for="txtData"> Anexo:</label>
          <div class="input-group" @drop="onUploadDrop" @dragover="onUploadDragover">
            <div class="upload" style="cursor: pointer;" @click="onUploadClick">
              <input
                multiple
                type="file"
                ref="inputFile"
                v-show="false"
                accept="*"
                @change="onFileChange"
              />
              <div><i class="fas fa-file-import" style="font-size: 17px"></i></div>
              <span v-if="!attach">Clique ou arraste aqui para anexar!</span>
              <span v-else>
                <span v-for="(upload, index) in attach" :key="index">{{ upload.name }} &nbsp;</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <template #modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn rounded btn-default btn-sm text-secundary" v-on:click="onClear" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonClear"><i class="fa fa-minus-circle"></i> <span class="d-md-down-none">{{$lang.Common.Buttons.Clear}}</span></button>&nbsp;
          <button v-if="eventManager" @click.prevent="storeSubmit" type="button" class="btn btn-third btn-sm"  v-b-tooltip.hover :title="eventManager.hasNext ? 'Próximo' : 'Salvar'"> <i :class="eventManager.hasNext ? 'far fa-arrow-alt-circle-right' : 'fas fa-check-circle'"></i><span class="d-md-down-none">&nbsp; {{ eventManager.hasNext ? 'Próximo' : 'Salvar' }}</span></button>
          <button v-else type="button" class="btn rounded btn-third btn-sm" v-on:click="onSave" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonSave"> <i class="fa fa-check-circle"></i> <span class="d-md-down-none">{{$lang.Common.Buttons.Save}}</span></button>&nbsp;
        </div>
      </template>
    <DespesasModal ref="DespesasModal" @onBackDespesas="updateDespesasList" @onBackDespesasFiles="updateDespesasFiles"/>
    </b-modal>
  </div>
</template>
<script>
import ModalNewFollowUp from './followup.js'
export default ModalNewFollowUp
</script>

<style>
.btn-timepicker {
  display: flex;
  align-items: center;
  padding: 0px 10px;
  border-radius: 6px;
  background-color: #fff;
  color: #131313;
  border-right-color: rgba(0, 0, 0, 0.15);
  border-top-color: rgba(0, 0, 0, 0.15);
  border-bottom-color: rgba(0, 0, 0, 0.15);
}

.timepicker-input-group {
  display: flex;
  width: 100%;
}

.btn-timepicker-input {
  flex-grow: 1;
}

.btn-timepicker-input,
.btn-timepicker-input:hover{
  border-right-color: transparent !important;
}
</style>
<style scoped>
.upload {
  border: solid 1px #ccc;
  border-radius: 4px;
  background-color: #efefef;
  padding: 3%;
  width: 100%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/details/followup/followup.vue